import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Container, Col, Row, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useCompanyStore, useUserStore, useBlogCategoriesStore } from 'stores';
// api
import { getPosts } from 'api/blog';
import { getActivities } from 'api/company';
//custom hooks
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
// components
import Head from 'components/metatags_helmet/metatags';
import BlogCategories from 'components/blog/BlogCategories';
import Pagination from 'components/userzone/Pagination';
import EventHome from 'pages/home/events';
import CardBlogCategory from 'components/blog/cardBlogCategory';
// images
import noImagePost from 'assets/img/feather.jpg';
// styles
import './blog.scss';

const Categoryblog = () => {
  const { t } = useTranslation(['blog']);
  const [loaded, setLoaded] = useState(false);
  const [allPostsLoaded, setAllPostsLoaded] = useState(false);
  const [listPostCategory, setListPostCategory] = useState([]);
  const [bigPost, setBigPost] = useState([{}]);
  const [smallPosts, setSmallPosts] = useState([]);
  const [totalNumberPost, setTotalNumberPost] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const { categories: blogCategories } = useBlogCategoriesStore();
  const { isLogged } = useUserStore();
  const company = useCompanyStore();
  const [events, setEvents] = useState([]);
  const { has_events } = company;
  const params = useParams();
  const { name, descripcion_pub } = useCompanyStore();
  const { id, category } = params;
  const { assignedLibrary } = useAssignedLibrary();
  const isLibrosDelMesSection = category === 'libros-del-mes';
  const title = `Mundo ${name}`;

  async function loadEvents() {
    const response = await getActivities({ page: 1, page_size: 3, actives: true });

    if (response?.status === 200) {
      let events = response?.data?.results.slice(0, 3);
      setEvents(events);
    }
  }

  useEffect(() => {
    if (!isLogged || has_events) {
      loadEvents();
    }
  }, [isLogged, has_events]);

  useEffect(() => {
    async function handlePagination() {
      const params = {
        category: id,
        page: currentPage,
        page_size: 10,
        fields: 'id,title,slug,featured_paragraph,featured_image,publish_date,status,category',
      };
      const { status, data } = await getPosts(params);
      if (status === 200) {
        setListPostCategory(data.results);
        setTotalNumberPost(data.count);
        setTotalPages(Math.ceil(data.count / 10));
        setLoaded(true);
      }
    }
    handlePagination();
    goUp();
  }, [currentPage, category]);

  const changePage = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  useEffect(() => {
    if (currentPage === 1) {
      setBigPost(listPostCategory.slice(0, 1));
      setSmallPosts(listPostCategory.slice(1));
      setAllPostsLoaded(true);
    } else {
      setSmallPosts(listPostCategory.slice(0));
      setAllPostsLoaded(true);
    }
  }, [listPostCategory]);

  const goUp = () => {
    window.scrollTo(0, 0);
  };

  return (
    <>
      {(!loaded || !allPostsLoaded) ?
        <Container fluid={true} className="d-flex justify-content-center align-items-center spinner-init">
          <Spinner animation={'grow'} />
        </Container> :
        (listPostCategory?.length > 0 || isLibrosDelMesSection) ?
          <div className="content mainDiv mx-auto">
            <div className="container-fluid mx-auto blog">
              <Head description={descripcion_pub} title={title} noIndex={true} />
              <Row>
                <Col md={12}>
                  <h1 className="page-title static-title">
                    {title} - {bigPost[0]?.category?.name}
                  </h1>
                </Col>
              </Row>
              <Row className="blogContainer justify-content-between m-0">
                <Col sm={12} lg={9}>
                  <Row className="containerPostList">
                    {listPostCategory.map((post, i) => (
                      <>
                        {i === 1 && (
                          <Col xs={12} className="mb-2">
                            <h2 className="section all-post-title">{t('allPosts')}</h2>
                          </Col>
                        )}
                        <Col key={post.id} xs={12} md={i === 0 ? 12 : 4} className="mb-5">
                          <CardBlogCategory
                            post={{ ...post, isFirstPost: i === 0 }}
                            assignedLibrary={assignedLibrary}
                          />
                        </Col>
                      </>
                    ))}
                  </Row>
                  {totalNumberPost > 1 && <Row className="mt-md-4 mt-0 mb-4">
                    <Col md={12} className="d-flex justify-content-center align-items-center">
                      <Pagination changePage={changePage} page={currentPage} totalPages={totalPages} />
                    </Col>
                  </Row>}
                </Col>
                <Col
                  lg={3} sm={12}
                  className="mt-md-5 mt-lg-0"
                >
                  {blogCategories.length > 0 && <BlogCategories blogCategories={blogCategories} />}
                  <EventHome events={events} onlyEvents />
                </Col>
              </Row>
            </div>
          </div> :
          <Container fluid={true} className='spinner-init'>
            <h4 className="text-center mt-5">{t('noResults')}</h4>
          </Container>
      }
    </>
  )
};

export default Categoryblog;